import type { Muelle, PlaceEvent } from '../domain/scales'
import type { EventRow } from './types'

export interface StayDate {
  planned: string | null
  actual: string | null
  differenceS: number | null
}

export interface StayDates {
  id: string
  muelle: Muelle
  arrival: StayDate
  departure: StayDate
  overdueS: number | null
  unconfirmed: boolean
}

const SECOND = 1000

const stayDate = (planned: string | null, actual: string | null): StayDate => ({
  planned,
  actual,
  differenceS: planned === null || actual === null ? null : Math.round((Date.parse(actual) - Date.parse(planned)) / SECOND),
})

const overdueS = (plannedEnd: string | null, actualEnd: string | null, now: number): number | null => {
  if (actualEnd !== null || plannedEnd === null) return null
  const passed = now - Date.parse(plannedEnd)
  return passed > 0 ? Math.round(passed / SECOND) : null
}

export const stayDates = (events: readonly EventRow[], now: number): StayDates[] =>
  events
    .filter((event): event is EventRow & PlaceEvent => event.type === 'PLACE')
    .sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime))
    .map(stay => {
      const unconfirmed = stay.actualEndTime === null && stay.actualsState === 'UNCONFIRMED'
      return {
        id: stay.id,
        muelle: stay.muelle,
        arrival: stayDate(stay.startTime, stay.actualStartTime),
        departure: stayDate(stay.endTime, stay.actualEndTime),
        overdueS: unconfirmed ? null : overdueS(stay.endTime, stay.actualEndTime, now),
        unconfirmed,
      }
    })
